import useApi from "./use-api";
import { useState } from "react";

interface DownloadFileProps {
  readonly onStart?: () => void;
  readonly onEnd?: () => void;
  readonly onError: () => void;
  readonly getFileName?: () => string;
}

interface DownloadedFileInfo {
  readonly downloadAction: (path: string, fileName?: string) => Promise<void>;
  readonly downloadLoading: boolean;
}

const useDownloadFile = ({
  onStart,
  onEnd,
  onError,
  getFileName,
}: DownloadFileProps): DownloadedFileInfo => {
  const api = useApi();
  const [downloadLoading, setDownloadLoading] = useState<boolean>(false);

  const downloadAction = async (path: string, fileName?: string) => {
    try {
      onStart?.();
      setDownloadLoading(true);
      const { data } = await api.get(path, { responseType: "blob" });

      const url = URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", getFileName?.() || fileName || "file"); //or any other extension
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
      onEnd?.();
      setDownloadLoading(false);
      URL.revokeObjectURL(url);
    } catch (error) {
      setDownloadLoading(false);
      onError();
    }
  };

  return { downloadAction, downloadLoading };
};

export default useDownloadFile;
